import { gql } from 'apollo-angular';

export const GET_POPSM_INSTITUTIONS_SERVICES_SUMMARY = gql`
  query GetOverallServiceSubmissionStatusReport($filtering: ServiceSubmissionStatusFilterInputObject) {
    getOverallServiceSubmissionStatusReport(filtering: $filtering) {
      response {
        id
        status
        code
        message
      }
      data {
        allInstitutions {
          institution {
            id
            institutionUniqueId
            institutionName
            institutionMinistry {
              id
              ministryUniqueId
              ministryName
            }
            institutionSector {
              id
              sectorUniqueId
              sectorName
            }
            institutionRegion {
              id
              regionalUniqueId
              reginalName
              reginalPostcode
              napaId
            }
            institutionDistrict {
              id
              districUniqueId
              districName
              districPostcode
              napaId
            }
            institutionWard {
              id
              wardUniqueId
              wardName
              wardPostcode
              napaId
            }
            institutionStreet {
              id
              streetUniqueId
              streetName
              streetPostcode
              napaId
            }
            institutionFunctions {
              id
              functionUniqueId
              functionDutyName
            }
          }
          totalServices
          apprServices
          draftServices
          rejectedServices
        }
        sumTotalServices
        sumApprServices
        sumDraftServices
        sumRejectedServices
        totalInst
      }
    }
  }
`;

export const GET_POPSM_INSTITUTIONS_SERVICES_SUMMARY_STATS = gql`
  query GetOverallServiceSubmissionStatusReport($filtering: ServiceSubmissionStatusFilterInputObject) {
    getOverallServiceSubmissionStatusReport(filtering: $filtering) {
      response {
        id
        status
        code
        message
      }
      data {
        sumTotalServices
        sumApprServices
        sumDraftServices
        sumRejectedServices
        totalInst
      }
    }
  }
`;

export const GET_MINISTRY_VS_TOTAL_SERVICE_REGISTRATION_SUMMARY = gql`
  query GetMinistryVsTotalServiceRegistrationSummary {
    getMinistryVsTotalServiceRegistrationSummary {
      response {
        id
        status
        code
        message
      }
      data {
        ministry {
          id
          ministryUniqueId
          ministryName
        }
        totalServices
        equivalentPercentage
        draftServices
        submittedServices
        approvedServices
        rejectedServices
      }
    }
  }`

export const GET_SECTOR_VS_TOTAL_SERVICE_REGISTRATION_SUMMARY = gql`
  query GetSectorVsTotalServiceRegistrationSummary {
    getSectorVsTotalServiceRegistrationSummary {
      response {
        id
        status
        code
        message
      }
      data {
        sector {
          id
          sectorUniqueId
          sectorCode
          sectorName
          sectorIcon
        }
        totalServices
        equivalentPercentage
        draftServices
        submittedServices
        approvedServices
        rejectedServices

      }
    }
  }
`
